import { Injectable } from '@angular/core';
import { global } from '../../../shared/global';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ExpenseDetailRequestService {

    constructor(private http: HttpClient) { }
    
    fillYear(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillYearMaster', data, global.httpOptions);
    }
    fillExpenseType(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillExpenseType', data, global.httpOptions);
    }
    getExpenseDetailRequestList(data) {
        return this.http.post(global.baseAPIUrl + 'ExpenseDetailRequest/getExpenseDetailRequestList', data, global.httpOptions);
    }
    getExpenseDetailRequestByID(data) {
        return this.http.post(global.baseAPIUrl + 'ExpenseDetailRequest/getExpenseDetailRequestByID', data, global.httpOptions);
    }
    saveExpenseDetailRequest(data) {
        return this.http.post(global.baseAPIUrl + 'ExpenseDetailRequest/saveExpenseDetailRequest', data, global.httpOptions);
    }
    deleteExpenseDetailRequest(data) {
        return this.http.post(global.baseAPIUrl + 'ExpenseDetailRequest/deleteExpenseDetailRequest', data, global.httpOptions);
    }
}